import type { SalaryInfoRequest, SalaryInfoResponse } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { del, get, post } from './request';

export const SERVICE_PATH = 'rest/resource/salaryinfo';

export function getSalaryInfo(): Promise<SalaryInfoResponse | undefined> {
    return get<SalaryInfoResponse>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}

export function saveSalaryInfo(salaryInfo: SalaryInfoRequest): Promise<unknown> {
    return post(`${CONTEXT_PATH}/${SERVICE_PATH}/`, salaryInfo);
}

export function deleteSalaryInfo(): Promise<unknown> {
    return del(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}
